/**
* DevExpress Dashboard (_rename-data-source-popup.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { RenameDataSourceViewModel } from './_rename-data-source-viewmodel';
export class RenameDataSourcePopup {
    constructor(dataSourceBrowser) {
        this._viewModel = new RenameDataSourceViewModel(dataSourceBrowser);
        this.template = {
            name: 'dx-dashboard-datasources-rename-popup',
            data: this._viewModel
        };
    }
    show(dataSource) {
        this._viewModel.show(dataSource);
    }
}
